import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import api from '../../utils/api';

export const initialState = fromJS({
  // Warehouse info
  data: null,
  isLoading: false,
  // Warehouse branches
  warehouseBranches: [],
  isLoadingWarehouseBranches: true,
});

// const
export const GET_WAREHOUSE_INFO = 'warehouse/GET_WAREHOUSE_INFO';
export const GET_WAREHOUSE_BRANCHES = 'warehouse/GET_WAREHOUSE_BRANCHES';

// action creators
export const getWarehouseInfo = createAction(
  GET_WAREHOUSE_INFO,
  api.warehouse.getWarehouseInfo,
);

export const getWarehouseBranches = createAction(
  GET_WAREHOUSE_BRANCHES,
  api.warehouse.getWarehouseBranches,
);

// reducer
const warehouseReducer = handleActions(
  {
    [`${GET_WAREHOUSE_INFO}_REQUEST`]: (state) => state.set('isLoading', true),

    [`${GET_WAREHOUSE_INFO}_SUCCESS`]: (state, { payload }) =>
      state.set('data', payload.get('data')).set('isLoading', false),

    [`${GET_WAREHOUSE_INFO}_ERROR`]: (state) => state.set('isLoading', false),

    // Warehouse branches
    [`${GET_WAREHOUSE_BRANCHES}_REQUEST`]: (state) =>
      state.set('isLoadingWarehouseBranches', true),

    [`${GET_WAREHOUSE_BRANCHES}_SUCCESS`]: (state, { payload }) =>
      state
        .set('warehouseBranches', payload.get('data').get('branches'))
        .set('isLoadingWarehouseBranches', false),

    [`${GET_WAREHOUSE_BRANCHES}_ERROR`]: (state) =>
      state.set('isLoadingWarehouseBranches', false),
  },
  initialState,
);

export default warehouseReducer;
